import Vue from 'vue'
import Router from 'vue-router'

import HomePage from '../components/HomePage'
import Information from '../components/Information'
import Company from '../components/Company'
import Legislation from '../components/Legislation'
import Project from '../components/Project'
import Steward from '../components/Steward'
import Contact from '../components/Contact'
import DetailInfo from '../components/DetailInfo'
Vue.use(Router)

const router = new Router({
    scrollBehavior(to,from,savePosition){
        // console.log(to,from,savePosition)
        if(savePosition){
            return savePosition
        }else{
            return{
                x: 0,
                y: 0
            }
        }
    },
    routes:[
        {
            path: '/',
            name: 'home',
            component: HomePage,
        },
        {
            path: '/steward',
            name: 'steward',
            component: Steward
        },
        {
            path: '/company',
            name: 'company',
            component: Company
        },
        {
            path: '/information',
            name: 'information',
            component: Information
        },
        {
            path: '/legislation',
            name: 'legislation',
            component: Legislation
        },
        {
            path: '/project',
            name: 'project',
            component: Project
        },
        {
            path: '/contact',
            name: 'contact',
            component: Contact
        },
        {
            path: '/detail',
            name: 'detail',
            component: DetailInfo,
            meta: {
                keepAlive: true // 不需要被缓存
            }
        },
    ]
})


export default router